import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getCampaignId = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.id'],
);
export const getCampaignStatus = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.status'],
);
export const getCampaignName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.name'],
);
export const getCampaignSchema = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema'],
);
export const getCampaignCategory = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.category'],
);
export const getCampaignCountry = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.tablecountry.country'],
);
export const getCampaignChannel = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.channel'],
);
export const getCampaignTarget = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.target'],
);
export const getCampaignActiveFrom = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.activefrom'],
);
export const getCampaignActiveUntil = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.activeuntil'],
);
export const getCampaignDescription = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.loyaltyrule.description'],
);
